// areasSlice.ts
import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { Area } from "../../typings/Area";
import { SliceStatus } from "../utils";
import areasApi from "./areasApi";

export const areasAdapter = createEntityAdapter<Area>();

const initialState = areasAdapter.getInitialState<{
  status: SliceStatus;
}>({
  status: SliceStatus.IDLE,
});

export const getAreas = createAsyncThunk<Area[], void>(
  "areas/getAreas",
  async () => {
    const data = await areasApi.getAreas();
    return data;
  }
);

export const areasSlice = createSlice({
  name: "areas",
  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getAreas.pending, (state) => {
      state.status = SliceStatus.LOADING;
    });

    builder.addCase(getAreas.fulfilled, (state, { payload }) => {
      areasAdapter.upsertMany(state, payload);
      state.status = SliceStatus.IDLE;
    });

    builder.addCase(getAreas.rejected, (state) => {
      state.status = SliceStatus.FAILED;
    });
  },
});

export default areasSlice.reducer;
